<template>
  <div v-loading="loadingLevel_1">
		<slot></slot>
    <div class="detail detailTop" style="margin-bottom: 10px;text-align: right">
      <div><span class="mark"></span><span>粉色背景列为复制列 </span><span class="mark"></span><span>黄色背景标示该单元格数据发生修改</span>
        <span style="margin-left: 10px">工资月份{{wageMonth}}</span>
      </div>
        <!--<el-radio-group v-model="radio" @change="changeRadioAction">
          <el-radio label="1">隐藏空列</el-radio>
          <el-radio label="2">重置</el-radio>
        </el-radio-group>-->
      <el-checkbox v-model="radio" @change="changeRadioAction">{{checkBoxMsg}}</el-checkbox>
      <div style="flex: 1;cursor: pointer">
        <!--<span  @click="previewWage()" :underline="false" >预览工资单1</span >-->
        <el-button type="primary" size="small" @click="previewWage()" :underline="false" >预览工资单</el-button>
      </div>
      <div v-if="!state">
        <el-link @click="toAddPage()" v-if="editState==yes" :underline="false">新增</el-link>
        <el-link @click="remove()" v-if="editState==yes" :underline="false">删除</el-link>
        <el-link @click="reloadDialogVisible=true" v-if="editState==yes" :underline="false">再次拉取数据</el-link>
        <el-link @click="update()" v-if="editState==yes" :underline="false">在线编辑</el-link>
        <!--   <el-button type="primary" size="small" @click="toAddPage()" v-if="editState==yes">新增</el-button> -->
        <!-- <el-button type="primary" size="small" @click="remove()" v-if="editState==yes">删除</el-button>
         <el-button type="primary" size="small" @click="reloadUpdateAll()" v-if="editState==yes">再次拉取数据</el-button>
         <el-button type="primary" size="small" @click="update()" v-if="editState==yes">在线编辑</el-button> -->

          <!--<template v-slot:buttons>
            <vxe-button v-if="false">按钮1</vxe-button>
          </template>-->

      </div>
      <div v-if="state">
        <el-link @click="batch()" :underline="false" v-if="editState==yes">批量处理</el-link>
        <el-link @click="save()" :underline="false">保存</el-link>
        <el-link @click="cancel()" :underline="false">取消</el-link>
        <!--  <el-button type="primary" size="small" @click="batch()" v-if="editState==yes">批量处理</el-button>
          <el-button type="primary" size="small" @click="save()">保存</el-button>
          <el-button type="primary" size="small" @click="cancel()">取消</el-button> -->
      </div>
    </div>
    <div style="height:calc(100vh - 215px)" class="gridContain">
      <vxe-grid
        id="toolbar_demo5"
        border
        show-footer
        :optimization="{scrollX: {gt: 200}}"
        :show-overflow="true"
        :show-header-overflow="true"
        keep-source
        resizable
        :loading="loading"
        auto-resize
        width="100%"
        highlight-hover-row
        height="100%"
        ref="table"
        :data="tableData"
        :edit-rules="validRules"
        :footer-method="footerMethod"
        :footer-cell-class-name="footerCellClassName"
        :custom-config="{storage: true, checkMethod: checkColumnMethod}"
        :tooltip-config="{enabled: true,theme:'light',contentMethod: showTooltipMethod}"
        :edit-config="{trigger: 'click', mode: 'cell', showStatus: true,activeMethod: activeCellMethod}"
        @edit-disabled="editActivedEvent"
        @edit-closed="editClosedEvent">
        <vxe-table-column v-for="(column,i) in tableColumn" :key='i' :type="column.type" :width="column.width"
                          :title="column.title" align="center" :fixed="column.fixed">
          <!--							 <template v-if="column.type=='seq'" v-slot="{ row}">-->
          <!--									<span>{{i}} <img v-if="JSON.parse(row.errorMsg)" style="margin-left: 8px;" src="@/assets/img/salary/icon-tuipiao.png"></span>-->
          <!--							</template>-->
          <template v-if="column.type!='seq' && column.type!='checkbox'" v-slot="{ row}">
                  <span>
                      <span>{{ row[column.field]}}</span>

                    <div  class="inlineBlock" style="display:inline-block;">
                                 <el-popover popper-class="loopBox" placement="bottom-start" width="296" trigger="hover">
                                  <svg class="icon popIcon" aria-hidden="true" slot="reference" style="color:red;"
                                       v-if="JSON.parse(row.errorMsg)&&JSON.parse(row.errorMsg)[column.field]">
                                    <use xlink:href="#icon-guanbi"></use>
                                  </svg>
                                  <svg class="icon popIcon" aria-hidden="true" slot="reference" style="color:#f952a4;"
                                       v-else-if="JSON.parse(row.warnMsg)&&JSON.parse(row.warnMsg)[column.field]">
                                    <use xlink:href="#icon-cuowu"></use>
                                  </svg>
                                  <svg class="icon popIcon" aria-hidden="true" slot="reference"
                                       v-else-if="JSON.parse(row.tipsMsg)&&JSON.parse(row.tipsMsg)[column.field]">
                                    <use xlink:href="#icon-tishi"></use>
                                  </svg>
                                     <div class="loopError" >
                                     <div class="loopType loopTypeError" v-if="JSON.parse(row.errorMsg)&&JSON.parse(row.errorMsg)[column.field]">
                                      <svg class="icon" aria-hidden="true" slot="reference">
                                        <use xlink:href="#icon-guanbi"></use>
                                      </svg>错误
                                       <div class="loopContent" >
                                          <div class="text-indent">{{JSON.parse(row.errorMsg)[column.field]}}</div>
                                       </div>
                                    </div>

                                     <div class="loopType loopTypeWarn" v-if="JSON.parse(row.warnMsg)&&JSON.parse(row.warnMsg)[column.field]">
                                      <svg class="icon" aria-hidden="true" slot="reference">
                                        <use xlink:href="#icon-cuowu"></use>
                                      </svg>警告
                                       <div class="loopContent">
                                         <div class="text-indent">{{JSON.parse(row.warnMsg)[column.field]}}</div>
                                       </div>
                                    </div>
                                    <div class="loopType loopTypeInfo" v-if="JSON.parse(row.tipsMsg)&&JSON.parse(row.tipsMsg)[column.field]">
                                      <svg class="icon" aria-hidden="true" slot="reference">
                                        <use xlink:href="#icon-tishi"></use>
                                      </svg>提示
                                        <div class="loopContent">
                                          <div  class="text-indent">{{JSON.parse(row.tipsMsg)[column.field]}}</div>
                                       </div>
                                    </div>
                                  </div>
                                 </el-popover>
                            </div>


                  </span>
          </template>
          <vxe-table-column  v-if="column.children" v-for="(child,index) in column.children" :key='index'
                            :field="child.field" align="center" :title="child.title" :data-title="child.title"
                            :editRender="child.editRender" :width="child.width" :visible="child.visible">
            <template v-slot="{ row}">
												<span
                          :class="{'updateMsg':(row.updateMsg&&row.updateMsg.indexOf(child.field)>=0),'copyMsg':(row.copyMsg&&row.copyMsg.indexOf(child.columnCode)>=0)}"
                          v-if="((!row.errorMsg||!JSON.parse(row.errorMsg)[child.field]) && child.editRender)
                          ||((!row.errorMsg||!JSON.parse(row.errorMsg)[child.field]) && !child.codeSetId)">

                           <span>{{ row[child.field] | tableDataFilter(child.editRender)}}</span>
                           <div  class="inlineBlock" style="display:inline-block;">
                                 <el-popover popper-class="loopBox" placement="bottom-start" width="296" trigger="hover">
                                  <svg class="icon popIcon" aria-hidden="true" slot="reference" style="color:red;"
                                       v-if="JSON.parse(row.errorMsg)&&JSON.parse(row.errorMsg)[child.field]">
                                    <use xlink:href="#icon-guanbi"></use>
                                  </svg>
                                  <svg class="icon popIcon" aria-hidden="true" slot="reference" style="color:#f952a4;"
                                       v-else-if="JSON.parse(row.warnMsg)&&JSON.parse(row.warnMsg)[child.field]">
                                    <use xlink:href="#icon-cuowu"></use>
                                  </svg>
                                  <svg class="icon popIcon" aria-hidden="true" slot="reference"
                                       v-else-if="JSON.parse(row.tipsMsg)&&JSON.parse(row.tipsMsg)[child.field]">
                                    <use xlink:href="#icon-tishi"></use>
                                  </svg>
                                     <div class="loopError" >
                                     <div class="loopType loopTypeError" v-if="JSON.parse(row.errorMsg)&&JSON.parse(row.errorMsg)[child.field]">
                                      <svg class="icon" aria-hidden="true" slot="reference">
                                        <use xlink:href="#icon-guanbi"></use>
                                      </svg>错误
                                       <div class="loopContent" >
                                          <div class="text-indent">{{JSON.parse(row.errorMsg)[child.field]}}</div>
                                       </div>
                                    </div>

                                     <div class="loopType loopTypeWarn" v-if="JSON.parse(row.warnMsg)&&JSON.parse(row.warnMsg)[child.field]">
                                      <svg class="icon" aria-hidden="true" slot="reference">
                                        <use xlink:href="#icon-cuowu"></use>
                                      </svg>警告
                                       <div class="loopContent">
                                         <div class="text-indent">{{JSON.parse(row.warnMsg)[child.field]}}</div>
                                       </div>
                                    </div>
                                    <div class="loopType loopTypeInfo" v-if="JSON.parse(row.tipsMsg)&&JSON.parse(row.tipsMsg)[child.field]">
                                      <svg class="icon" aria-hidden="true" slot="reference">
                                        <use xlink:href="#icon-tishi"></use>
                                      </svg>提示
                                        <div class="loopContent">
                                          <div  class="text-indent">{{JSON.parse(row.tipsMsg)[child.field]}}</div>
                                       </div>
                                    </div>


                                  </div>
                                 </el-popover>
                            </div>
												</span>
              <span
                :class="{'updateMsg':(row.updateMsg&&row.updateMsg.indexOf(child.field)>=0),'copyMsg':(row.copyMsg&&row.copyMsg.indexOf(child.columnCode)>=0)}"
                v-if="(!row.errorMsg||!JSON.parse(row.errorMsg)[child.field]) && !child.editRender && child.codeSetId">
													 <span>{{ row[child.field] | bspTableFilter({'1':'dict', '2':dicts})}}</span>
                                           <div  class="inlineBlock" style="display:inline-block;">
                                 <el-popover popper-class="loopBox" placement="bottom-start" width="296" trigger="hover">
                                  <svg class="icon popIcon" aria-hidden="true" slot="reference" style="color:red;"
                                       v-if="JSON.parse(row.errorMsg)&&JSON.parse(row.errorMsg)[child.field]">
                                    <use xlink:href="#icon-guanbi"></use>
                                  </svg>
                                  <svg class="icon popIcon" aria-hidden="true" slot="reference" style="color:#f952a4;"
                                       v-else-if="JSON.parse(row.warnMsg)&&JSON.parse(row.warnMsg)[child.field]">
                                    <use xlink:href="#icon-cuowu"></use>
                                  </svg>
                                  <svg class="icon popIcon" aria-hidden="true" slot="reference"
                                       v-else-if="JSON.parse(row.tipsMsg)&&JSON.parse(row.tipsMsg)[child.field]">
                                    <use xlink:href="#icon-tishi"></use>
                                  </svg>
                                   <div class="loopError" >
                                     <div class="loopType loopTypeError" v-if="JSON.parse(row.errorMsg)&&JSON.parse(row.errorMsg)[child.field]">
                                      <svg class="icon" aria-hidden="true" slot="reference">
                                        <use xlink:href="#icon-guanbi"></use>
                                      </svg>错误
                                       <div class="loopContent" >
                                          <div class="text-indent">{{JSON.parse(row.errorMsg)[child.field]}}</div>
                                       </div>
                                    </div>
                                     <div class="loopType loopTypeWarn" v-if="JSON.parse(row.warnMsg)&&JSON.parse(row.warnMsg)[child.field]">
                                      <svg class="icon" aria-hidden="true" slot="reference">
                                        <use xlink:href="#icon-cuowu"></use>
                                      </svg>警告
                                       <div class="loopContent">
                                         <div class="text-indent">{{JSON.parse(row.warnMsg)[child.field]}}</div>
                                       </div>
                                    </div>
                                    <div class="loopType loopTypeInfo" v-if="JSON.parse(row.tipsMsg)&&JSON.parse(row.tipsMsg)[child.field]">
                                      <svg class="icon" aria-hidden="true" slot="reference">
                                        <use xlink:href="#icon-tishi"></use>
                                      </svg>提示
                                        <div class="loopContent">
                                          <div  class="text-indent">{{JSON.parse(row.tipsMsg)[child.field]}}</div>
                                       </div>
                                    </div>


                                  </div>
                                 </el-popover>
                            </div>

												</span>
                  <span
                :class="{'updateMsg':(row.updateMsg&&row.updateMsg.indexOf(child.field)>=0),'copyMsg':(row.copyMsg&&row.copyMsg.indexOf(child.columnCode)>=0)}"
                style="display: flex;align-items: center;justify-content: center;"
                v-if="JSON.parse(row.errorMsg)&&JSON.parse(row.errorMsg)[child.field]">
													<span style="color:red">{{ row[child.field] | tableDataFilter(child.editRender)  }}</span>
<!--														<img style="margin-left: 8px;" src="@/assets/img/salary/icon-tuipiao.png">-->
                                               <div  class="inlineBlock" style="display:inline-block;">
                                 <el-popover popper-class="loopBox" placement="bottom-start" width="296" trigger="hover">
                                  <svg class="icon popIcon" aria-hidden="true" slot="reference" style="color:red;"
                                       v-if="JSON.parse(row.errorMsg)&&JSON.parse(row.errorMsg)[child.field]">
                                    <use xlink:href="#icon-guanbi"></use>
                                  </svg>
                                  <svg class="icon popIcon" aria-hidden="true" slot="reference" style="color:#f952a4;"
                                       v-else-if="JSON.parse(row.warnMsg)&&JSON.parse(row.warnMsg)[child.field]">
                                    <use xlink:href="#icon-cuowu"></use>
                                  </svg>
                                  <svg class="icon popIcon" aria-hidden="true" slot="reference"
                                       v-else>
                                    <use xlink:href="#icon-tishi"></use>
                                  </svg>
                                   <div class="loopError" >
                                     <div class="loopType loopTypeError" v-if="JSON.parse(row.errorMsg)&&JSON.parse(row.errorMsg)[child.field]">
                                      <svg class="icon" aria-hidden="true" slot="reference">
                                        <use xlink:href="#icon-guanbi"></use>
                                      </svg>错误
                                       <div class="loopContent" >
                                          <div class="text-indent">{{JSON.parse(row.errorMsg)[child.field]}}</div>
                                       </div>
                                    </div>
                                     <div class="loopType loopTypeWarn" v-if="JSON.parse(row.warnMsg)&&JSON.parse(row.warnMsg)[child.field]">
                                      <svg class="icon" aria-hidden="true" slot="reference">
                                        <use xlink:href="#icon-cuowu"></use>
                                      </svg>警告
                                       <div class="loopContent">
                                         <div class="text-indent">{{JSON.parse(row.warnMsg)[child.field]}}</div>
                                       </div>
                                    </div>
                                    <div class="loopType loopTypeInfo" v-if="JSON.parse(row.tipsMsg)&&JSON.parse(row.tipsMsg)[child.field]">
                                      <svg class="icon" aria-hidden="true" slot="reference">
                                        <use xlink:href="#icon-tishi"></use>
                                      </svg>提示
                                        <div class="loopContent">
                                          <div  class="text-indent">{{JSON.parse(row.tipsMsg)[child.field]}}</div>
                                       </div>
                                    </div>
                                  </div>
                                 </el-popover>
                            </div>
                        </span>
            </template>
          </vxe-table-column>
        </vxe-table-column>
        <template v-slot:empty>
          <span>
            <svg class="icon icon-kong" aria-hidden="true" style="font-size: 40px;color: #999">
                  <use xlink:href="#icon-kong"></use>
                </svg>
            <p class="noData">暂无数据</p>
          </span>
        </template>
      </vxe-grid>

    </div>

    <el-dialog
      ref="selectPerson"
      width="70%"
      id="selectPerson"
      v-dialogDrag
      :close-on-click-modal="false"
      :close-on-press-escape="false"
      title="选取人员"
      :visible.sync="dialogheaderVisible"
      v-if='dialogheaderVisible'
      :destroy-on-close="true"
    >
      <selectPerson :payGroupId="payGroupId"
                    :batchId="batchId"
                    :templateId="templateId"
                    :orgId="orgId"
                    :taxType="taxType"
                    :wageMonth="wageMonth"
                    :socMonth="socMonth"
                    :taxMonth="taxMonth"
                    :payWay="payWay"
                    :isCompute="isCompute"
                    :regionId="regionId"
                    :perDatas.sync="perDatas"
                    :state="state"
                    v-on:personDatas="personClick"
                    v-on:_getSalaryHistoryData="_getSalaryHistoryData">

      </selectPerson>
    </el-dialog>
    <!-- 新增和修改 -->
    <el-dialog
      :title="infoDialogTitle"
      :visible.sync="infoDialogVisible"
      v-dialogDrag
      :close-on-click-modal="false"
      :close-on-press-escape="false"
      width="40%"
    >
      <el-form
        :model="form"
        class="editForm"
        label-width="250px"
        label-suffix="："
        v-loading="infoLoading"
        :rules="rules"
        :ref="'form'+idx"
      >
        <el-form-item label="选择更新列" prop="column" v-if="infoDialogVisible"
                      :rules="[
      { required: true, message: '更新列不能为空', trigger: 'blur'}]">
          <el-select v-model="form.column" multiple filterable="true" collapse-tags @change="changeItem"
                     placeholder="请选择更新列">
            <el-option
              v-for="item in columnData"
              :key="item.value"
              :label="item.name"
              :value="item.value">
            </el-option>
          </el-select>
        </el-form-item>
        <div class="item" v-for="(item,i) in itemData" :key="item.id">
          <div v-if="item.valueType===INFO_ITEM_DATA_TYPE_STRING"><!--文本类型-->
            <el-form-item
              :label="item.name"
              :prop="item.field"
              :rules="item.valueNotNull==INFO_ITEM_VALUE_NOT_NULL?[{ required: true, message: '更新列不能为空', trigger: 'blur'}]:[]"
            >
              <el-input v-model="form[item.field]"></el-input>
            </el-form-item>
          </div>
          <div v-if="item.valueType===INFO_ITEM_DATA_TYPE_CODE"><!--代码类型-->
            <el-form-item
              :label="item.name"
              :prop="item.field"
              :rules="item.valueNotNull==INFO_ITEM_VALUE_NOT_NULL?[{ required: true, message: '更新列不能为空', trigger: 'blur'}]:[]"
            >
              <el-select v-model="form[item.field]">
                <el-option
                  v-for="item in dicts.codeList[item.codeSetId]"
                  :key="item.codeItemId"
                  :label="item.codeItemName"
                  :value="item.codeItemId">
                </el-option>
              </el-select>
            </el-form-item>
          </div>
          <div v-if="item.valueType===INFO_ITEM_DATA_TYPE_FLOAT">
            <el-form-item
              :label="item.name"
              :prop="item.field"
              :rules="item.valueNotNull==INFO_ITEM_VALUE_NOT_NULL?[{ required: true, message: '更新列不能为空', trigger: 'blur'},{ type: 'number', message:item.name+'为小数值'}]:[{ type: 'number', message:item.name+'为小数值'}]"
            >
              <el-input-number v-model="form[item.field]" :precision="2" :step="0.01"
                               placeholder="小数"></el-input-number>
            </el-form-item>
          </div>
          <div v-if="item.valueType===INFO_ITEM_DATA_TYPE_INT">
            <el-form-item
              :label="item.name"
              :prop="item.field"
              :rules="item.valueNotNull==INFO_ITEM_VALUE_NOT_NULL?[{ required: true, message: '更新列不能为空', trigger: 'blur'},{ type: 'number', message:item.name+'为整数值'}]:[{ type: 'number', message:item.name+'为整数值'}]"
            >
              <el-input v-model.number="form[item.field]" placeholder="整数"></el-input>
            </el-form-item>
          </div>
        </div>

      </el-form>
      <span slot="footer" class="dialog-footer">
        <el-button type="primary" @click="saveOrUpdate('form'+idx)">确定修改</el-button>
        <el-button @click="cancelHandler('form'+idx)">取 消</el-button>
      </span>
    </el-dialog>
    <!--再次拉取-->
    <el-dialog title="再次拉取数据" v-dialogDrag :visible.sync="reloadDialogVisible">
      <div class="reload-flex">

        <div class="icon-wrap">
          <div>
            <svg class="icon" aria-hidden="true">
              <use xlink:href="#icon-ic-renliziyuanguanli"></use>
            </svg>
          </div>
          <el-checkbox v-model="reloadUpdate.info" label="基本人员信息"></el-checkbox>
        </div>


        <div class="icon-wrap">
          <div>
            <svg class="icon" aria-hidden="true">
              <use xlink:href="#icon-gongzitiao"></use>
            </svg>
          </div>
          <el-checkbox v-model="reloadUpdate.salary" label="基础工资"></el-checkbox>
        </div>
      </div>
      <div style="text-align: center;margin-top: 20px">
        <el-button @click="reloadDialogVisible=false">取消</el-button>
        <el-button type="primary" @click="reloadUpdateAll()">确定</el-button>
      </div>
    </el-dialog>
    <!--预览工资单-->
    <el-dialog v-dialogDrag
               ref=""
               width="70%"
               id="PaySlip"
               :close-on-click-modal="true"
               :close-on-press-escape="true"
               title="工资条"
               :visible.sync="dialogpaySlipVisible"
    >
      <paySlipItem :itemLists="itemLists"></paySlipItem>
    </el-dialog>
  </div>
</template>

<script>
  import {
    getItemColumnData,
    getItemDataList,
    saveItemData,
    getSelectData,
    getItemDatas,
    deleteItemData,
    reloadUpdateAll
  } from "@/api/wage/batchTemplate";
  import selectPerson from "@/views/wage/dataReadyTemplate/selectPerson.vue";
  import {mapGetters} from 'vuex';
  import store from '@/store';
  import {bspTableFilter} from '@/filters/index.js';
  import {commonConst} from "@/const/code";
  import paySlipItem from "./paySlipItem";
  import XEUtils from 'xe-utils';
  import {queryPayrollPreView} from '@/api/wage/pay'

  export default {
    name: "table",
    components: {selectPerson,paySlipItem},
    props: {
      idx: {
        type: Number,
        default: 0
      },
      batchId: {
        type: Number,
        default: ''
      },
      taxType: {
        type: Number,
        default: ''
      },
      templateId: {
        type: Number,
        default: ''
      },
      payGroupId: {
        type: Number,
        default: ''
      },
      orgId: {
        type: Number,
        default: ''
      },
      wageMonth: {
        type: String,
        default: ''
      },
      socMonth: {
        type: String,
        default: ''
      },
      taxMonth: {
        type: String,
        default: ''
      },
      payWay: {
        type: String,
        default: ''
      },
      editState: {
        type: String,
        default: ''
      },
      isCompute: {
        type: String,
        default: ''
      },
      regionId: {
        type: String,
        default: ''
      },
      isHistoryFlag: {
        type: String,
        default: 'false'
      },
      tableData: {
        type: Object,
        // eslint-disable-next-line vue/require-valid-default-prop
        default: []
      },
      tableDataCopy: {
        type: Object,
        // eslint-disable-next-line vue/require-valid-default-prop
        default: []
      },
    },
    created() {
      this._getItemColumnData();//获取列头数据
      this._getItemDataList();//赋值_getItemDataList
      this._getSelectData();//获取下拉数据
      this._getExistEmp();//获取已经存在的雇员
    },
    mounted() {
    },
    computed: {
      ...mapGetters([
        'dicts',
      ]),
    },
    filters: {
      tableDataFilter(value, editor) {
        if (editor && editor.options) {
          let labelArr = editor.options.filter(option => {
            if (option.value == value) {
              return option.label;
            }
          });
          if (labelArr[0]) {
            return labelArr[0].label;
          }
        }
        return value;

      },
      tableDataFilterByCode(value, codeItemId) {
        if (codeItemId) {
          let valueFy = bspTableFilter({'1': 'dict', '2': dicts});
          if (valueFy) {
            return valueFy;
          }
          return value;
        }
      }

    },
    data() {
      return {
        /*rules:{
          pass: [
            { validator: validatePass, trigger: 'change' }
          ]
        },*/


        radio: false,
        checkBoxMsg:'隐藏空列',
        hiddenColumns:[],
        expHiddenColumns:[],//需要隐藏的列
        hidden:false,
        loadingLevel_1:false,//最外层遮罩
        loading: false,
        changeCells: {},
        //dicts:this.dicts,
        dialogheaderVisible: false,
        dialogpaySlipVisible:false,
        paySlipType:'',
        salaryDetailId:'',
        salaryDetail:'',
        infoDialogVisible: false,
        infoDialogTitle: "批量更新",
        yes: commonConst.YES,//可编辑
        no: commonConst.NO,//不可编辑
        INFO_ITEM_DATA_TYPE_INT: commonConst.INFO_ITEM_DATA_TYPE_INT,//整数
        INFO_ITEM_DATA_TYPE_FLOAT: commonConst.INFO_ITEM_DATA_TYPE_FLOAT,//小数
        INFO_ITEM_DATA_TYPE_STRING: commonConst.INFO_ITEM_DATA_TYPE_STRING,//文本
        INFO_ITEM_DATA_TYPE_CODE: commonConst.INFO_ITEM_DATA_TYPE_CODE,//代码
        INFO_ITEM_VALUE_NOT_NULL: commonConst.INFO_ITEM_VALUE_NOT_NULL,//值不能为空
        state: false,
        //taxType:'',
        itemIds: [],
        itemData: [],//可编辑项
        perDatas: [],//用于存储已在列表的的雇员id
        //分页查询对象
        listQuery: {
          limit: 20,
          page: 1,
          total: 0,
          batchId: '',
          templateId: '',
          isHistoryFlag: 'false'
        },
        itemLists: [],
        param: {
          empId: '',
          detailId: '',
          batchId: '',
        },
        form: {
          column: [],
        },
        columnData: [],
        //tableData: [],
        //tableDataCopy:[],
        fieldList: [],//字段数据
        validRules: {
            e204005:[
                {
                    pattern:/-?[1-9]\d*/,
                    message:"请填写正确的数字"
                }
            ],
        },
        tableColumn: [
          /*{field:'empName',title:'员工姓名',editRender:{ name: 'input' }},
          {title:'姓名',children: [{field:'Name1',title:'姓名1',editRender:{ name: 'input' }},{field:'Name2',title:'姓名2',editRender:{ name: 'input' }}]
          },*/
        ],
        sumListCode:[],
        reloadDialogVisible: false,
        reloadUpdate: {
          salary: true,
          info: true,
        }
      }
    },
    methods: {

      //显示
      showAction(){
        if(this.hidden && this.hiddenColumns && this.hiddenColumns.length>0){
          this.hidden = false;
          this.hiddenColumns.forEach(filed=>{
            this.$refs.table.showColumn(this.$refs.table.getColumnByField(filed));
          })
        }
      },
      //重置
      resetAction(){
        this.hidden = false;
        this.$refs.table.resetColumn();
      },
      changeRadioAction(){
        if (this.radio) {
          this.hiddenAction();//隐藏
          //this.checkBoxMsg='重置';
        }else{
          this.resetAction();//重置
          //this.checkBoxMsg='隐藏空列';
        }
      },
      //隐藏
      hiddenAction(){
        this.expHiddenColumns = []; // 清空
        if(this.hiddenColumns && this.hiddenColumns.length>0){
          this.hidden=true;
          // 先收集所有需要隐藏的列对象
          const allCols = [];
          this.tableColumn.forEach(col => {
            // 检查自身field
            if (col.field && !this.hiddenColumns.includes(col.field)) {
              allCols.push(col);
            }
            // 检查分组列
            if (col.grounpColumns && Array.isArray(col.grounpColumns)) {
              const hasChild = col.grounpColumns.some(sub => !this.hiddenColumns.includes(sub.field));
              if (hasChild) {
                allCols.push(col);
              }
            }
          });
          // 去重
          this.expHiddenColumns = [...new Set(allCols)];
          // 然后执行隐藏操作，遍历hiddenColumns
          this.hiddenColumns.forEach(filed => {
            this.$refs.xGrid.hideColumn(this.$refs.xGrid.getColumnByField(filed));
          });
        }
      },
      //自定义展示列方法
      checkColumnMethod ({ column }) {
        if (column.property === 'role') {
          return false
        }
        return true
      },
      footerCellClassName ({ $rowIndex, column, columnIndex }) {
        if (columnIndex === 1) {
          if ($rowIndex === 0) {
            return 'col-blue'
          } else {
            return 'col-red'
          }
        }
      },
      // 在值发生改变时更新表尾合计
      updateFooterEvent (params) {
        let xTable = this.$refs.table
        xTable.updateFooter()
      },
      footerMethod ({ columns, data }) {
        this.hiddenColumns = [];
        const result = [
          columns.map((column, columnIndex) => {

            if(data&&data.length>0){
              let columFiled = column.property;
              let result = XEUtils.every(data,(data)=>{
                return data[columFiled] ===0 || data[columFiled]===null
                  || data[columFiled] === '0'|| data[columFiled] === '0.0'|| data[columFiled] === '0.00'
              })
              if(result){
                this.hiddenColumns.push(columFiled)
              }
            }

            if (columnIndex === 3) {
              return '合计'
            }
            if (this.sumListCode.includes(column.property)) {
              return XEUtils.sum(data, column.property)
            }
            return null
          })
        ]

        this.$nextTick(() => {
          if (this.radio) {
            this.hiddenAction();
          }
        });
        return result;
      },
      getResult() {
        queryPayrollPreView(this.param).then(res => {
          let data=res.data
          if (data.msg==="success") {
            this.itemLists = data.data.dataList
            this.dialogpaySlipVisible = true;
          }else {
            this.$message.error("暂无数据");
          }
        })
      },
      previewWage(){
        const arr = this.$refs.table.getCheckboxRecords();
        if(arr &&arr.length>0){
          if(arr.length>1){
            this.$message.error("请选择一条薪资记录");
          }else{
            this.param.empId = arr[0].empId;
            this.param.detailId = arr[0].id;
            this.param.batchId = arr[0].batchId
            this.getResult();
          }
        }else{
          this.$message.error("至少选择一行数据");
        }
      },
      editClosedEvent({row, rowIndex, column, columnIndex}) {
        const {property} = column
        if (!this.changeCells['rowIndex' + rowIndex]) {
          this.changeCells['rowIndex' + rowIndex] = {rowIndex, columnIndexArr: [property]}
        } else {
          if (this.changeCells['rowIndex' + rowIndex].columnIndexArr.indexOf(property) < 0) {
            this.changeCells['rowIndex' + rowIndex].columnIndexArr.push(property);
          } else {
            if (this.changeCells['rowIndex' + rowIndex].columnIndexArr.length == 1) {
              delete this.changeCells['rowIndex' + rowIndex];
              return;
            }
            let index = this.changeCells['rowIndex' + rowIndex].columnIndexArr.indexOf(property);
            this.changeCells['rowIndex' + rowIndex].columnIndexArr.splice(index, 1);
          }
        }
      },
      showTooltipMethod({type, column, row, items, _columnIndex}) {
        if (row) {
          let {errorMsg} = row;
          const {property} = column;
          return ''
        } else {
          return null
        }
      },
      changeItem(e) {
        this.itemIds = e;
        this._getItemDatas();
      },
      _getItemDatas() {
        let o = {list: this.itemIds};
        getItemDatas(o).then(res => {
          let rs = res.data;
          if (rs.code == 0) {
            this.itemData = res.data.data;
          } else {
            this.$message.error('系统出错')
          }
        })
      },
      batch() {
        if(this.hidden){
          //显示列，重置
          this.$refs.table.resetColumn();
        }
        this.infoDialogVisible = true;
        this.itemData = [];
        Vue.set(this.form, 'column', []);

      },
      cancelHandler(formName) {
        //如果有隐藏，就回复隐藏
        if(this.hidden){
          this.hiddenAction();//隐藏
        }
        //this.resetForm(formName);
        this.$refs[formName].resetFields();
        this.itemIds = [];
        this.infoDialogVisible = false;
        //this.changeEdit(index);
      },
      saveOrUpdate(formName) {
        this.$refs[formName].validate((valid) => {
          if (valid) {
            const selectRecords = this.$refs.table.getCheckboxRecords();//选中的数据
            //如果有选中的数据只批量给选中的数据赋值
            if (selectRecords.length) {
              selectRecords.forEach(item => {
                let rowIndex = this.$refs.table.getRowIndex(item);
                //改变的单元格，提取公共部分
                this.changByForm(rowIndex);
                Object.assign(item, this.form);
              })
            } else {
              for (let i = 0; i < this.$refs['table'].data.length; i++) {
                Object.assign(this.tableData[i], this.form);
                let rowIndex = i;
                //改变的单元格，提取公共部分
                this.changByForm(rowIndex);
              }
            }
            this.infoDialogVisible = false;
            //如果有隐藏，就回复隐藏
            if(this.hidden){
              this.hiddenAction();//隐藏
            }
          } else {
            this.$message.error('输入数据不合法,请按要求修改数据')
            return false;
          }
        });

      },
      changByForm(rowIndex) {
        for (let key in this.form) {
          if (key != 'column') {
            if (!this.changeCells['rowIndex' + rowIndex]) {
              this.changeCells['rowIndex' + rowIndex] = {rowIndex, columnIndexArr: [key]}
            } else {
              this.changeCells['rowIndex' + rowIndex].columnIndexArr.push(key);
            }
          }
        }
      },
      remove() {
        const selectRecords = this.$refs.table.getCheckboxRecords();
        if (selectRecords.length) {
          this.$confirm('是否确认删除数据?', '提示', {
            confirmButtonText: '确定',
            cancelButtonText: '取消',
            type: 'warning'
          }).then(() => {
            this.loadingLevel_1 = true
            for (let i = 0; i < selectRecords.length; i++) {
              this.$refs.table.remove(selectRecords[i]);
            }
            //删除后保存
            let o = {
              delete: this.$refs.table.getRemoveRecords(),
              batchId: this.batchId
            };
            deleteItemData(o).then(res => {
              this.loadingLevel_1 = false
              let rs = res.data;
              if (rs.code == 0) {
                this.$message.success('删除成功')
                //this.$emit('_getSalaryHistoryData');//调用父类刷新方法
                this.$router.go(0);//刷新当前页
              }
            })
          })
        } else {
          this.$message.error('请至少选择一条数据')
        }
      },
      cancel() {
        this._getItemDataList();
        this.state = !this.state;
      },
      update() {
        this.state = !this.state;
      },
      activeCellMethod({column, columnIndex}) {
        if (this.state == true) {
          return true//
        }
        return false
      },
      editActivedEvent({row, column}, event) {
      },
      //复选框单选事件
      selectChange({checked, row}) {
      },
      //复选框全选事件
      selectAll({checked, selection}) {
      },
      toAddPage() {
        this.dialogheaderVisible = true
        //let obj = {perName:'李斯',idCard:'11111',name:''};
        //this.$refs.table.insert(obj,0)
      },

      personClick(e1) {
        this.dialogheaderVisible = e1.dialog;
        /*var selectArr = this.perDatas;
        e1.data.map(function (item) {
          selectArr.push(item)
        })
        this.perDatas = selectArr;*/
        //this.insertEvent(e1.data);
      },
      _getSalaryHistoryData() {
        //this.$emit('_getSalaryHistoryData');//调用父类方法
        this.$router.go(0);//刷新当前页
      },
      insertEvent(obj) {
        let arr = obj;
        for (let i = 0; i < arr.length; i++) {
          let item = arr[i];
          let obj = {empName: item.empName, idCard: item.idCard, costCenter: item.costCenter, taxType: this.taxType};
          this.fieldList.forEach(item => {
            if (item.field != 'empName' && item.field != 'idCard' && item.field != 'costCenter' && item.taxType != 'taxType') {
              obj[item.field] = item.value;
            }
          });
          //let obj = {perName:'李斯',idCard:'11111',name:''};
          this.$refs.table.insert(obj, 0);
          // 插入一条数据并触发校验
          /*const errMap =  this.$refs.table.table.validate(newRow).catch(errMap => errMap);
          if (errMap) {

          }*/
        }

      },
      getSelectEvent() {
        let selectRecords = this.$refs.table.getCheckboxRecords()
        this.$XModal.alert(selectRecords.length)
      },
      getInsertEvent() {
        let insertRecords = this.$refs.table.getInsertRecords()
        return insertRecords;
      },
      getRemoveEvent() {
        let removeRecords = this.$refs.table.getRemoveRecords()
        this.$XModal.alert(removeRecords.length)
      },
      getUpdateEvent() {
        let updateRecords = this.$refs.table.getUpdateRecords()
        this.$XModal.alert(updateRecords.length)
      },
      //获取表头数据
      _getItemColumnData() {
        let o = {batchId: this.batchId, templateId: this.templateId};
        this.loading = true;

        this.tableColumn = [];
        this.validRules = {};
        this.fieldList = []
        getItemColumnData(o).then(res => {
          let rs = res.data;
          if (rs.code == 0) {
            let tableColumn = res.data.data.tableColumn;
            let sumListCode = res.data.data.sumListCode;
            this.tableColumn = tableColumn;
            this.sumListCode = sumListCode;
            /*this.tableColumn.splice(2, 0, {
              title: '雇员姓名',
              field: 'empName',
              colIndex: 1,
              width: 90,
            }, {
              field: 'idCard',
              title: '证件号码',
              width: 150,
            });*/
            this.$nextTick(()=>{
              this.$set(this,'validRules',res.data.data.validMap);

                // 将指定列设置为隐藏状态
              /*tableColumn.forEach(column => {
                  if(column.children){
                    let childs = column.children;
                    childs.forEach(child=>{
                      if('payAmount'===child.field){
                        child.visible = false
                      }
                    })
                  }
                })*/
                /*if (this.$refs.table) {
                  this.$refs.table.refreshColumn()//刷新列
                }
              alert(JSON.stringify(this.tableColumn))*/
                // this.radio = true
                // this.changeRadioAction()
            })

            this.fieldList = res.data.data.fieldList;

          }/*else{
            this.$message.error('获取薪资项出现问题')
          }*/
          this.resetAction();//重置一下，避免缓存不显示
          this.loading = false;



          // setTimeout(() => {
          //   this.radio = true
          //   this.changeRadioAction()
          // },400)

        })

      },
      _getSelectData() {
        let o = {batchId: this.batchId, templateId: this.templateId};
        getSelectData(o).then(res => {
          let rs = res.data;
          if (rs.code == 0) {
            this.columnData = res.data.data;
          } else {
            this.$message.error('获取更细列数据出现问题')
          }
        })
      },
      // 复制方法
      _getItemDataList() {
        /*this.listQuery.batchId = this.batchId;
        this.listQuery.templateId = this.templateId;
        this.listQuery.isHistoryFlag = this.isHistoryFlag;
        this.listQuery.wageMonth = this.wageMonth;*/

        if (this.tableDataCopy.length == 0) {
          this.tableDataCopy = JSON.parse(JSON.stringify(this.tableData));
        }

        /*getItemDataList(this.listQuery).then((res) => {
          this.listQuery.total = res.data.total

          this.tableData = res.data.records;
					if(this.tableDataCopy.length==0){
						this.tableDataCopy = JSON.parse(JSON.stringify(this.tableData));
					}
        });*/
      },
      _getExistEmp() {
        if (this.tableData) {
          let personList = this.tableData;
          personList.forEach(row => {
            let obj = {
              id: row.empId
            }
            this.perDatas.push(obj);
          })
        }
      },
      reloadUpdateAll() {
        //重新拉取更新同一批次下的、证件号的批次信息，即：从新获取sys中的人员信息更新
        let idCardList = []
        if (this.tableData) {
          this.tableData.forEach(item => {
            idCardList.push(item.idCard)
          })
          let baseWage, baseEmpInfo;
          let infoMsg = [];
          if (this.reloadUpdate.salary) {
            baseWage = "92610002"//"基本工资"
            infoMsg.push(baseWage);
          } else {
            baseWage = ""
          }
          if (this.reloadUpdate.info) {
            baseEmpInfo = "92610001"//"基本人员信息"
            infoMsg.push(baseEmpInfo)
          } else {
            baseEmpInfo = ""
          }
          if (!baseWage && !baseEmpInfo) {
            this.$message.error('至少勾选一项')
            return
          } else {
            let data = {batchId: this.batchId, idCardList: idCardList, infoMsg: infoMsg, payGroupId: this.payGroupId};
            this.reloadDialogVisible=false
            this.loadingLevel_1 = true;
            reloadUpdateAll(data).then(res => {
              this.loadingLevel_1 = false;
              let re = res.data
              if (re.code == 0) {
                this.$message.success('重新拉取成功')
                //this.reloadDialogVisible = false
                this.$router.go(0);//刷新当前页
              }
            })
          }

          /*this.$confirm('是否确认重新拉取?','提示',{
            confirmButtonText: '确定',
            cancelButtonText: '取消',
            type: 'warning'
          }).then(()=>{
          })*/


        }
      },
      async save() {
        const errMap = await this.$refs.table.fullValidate().catch(errMap => errMap);
        if (!errMap) { //通过校验
          if(this.hidden){
            this.resetAction();//重置显示，如果有隐藏就保存显示，不然一下代码会报错
          }
          const cells = {}
          let changCellFields = {};//所有发生change的单元格集合，键:idCard，值:发生改变的字段
          for (let key in this.changeCells) {
            let rowIndex = this.changeCells[key].rowIndex;
            let paramField = {};
            this.changeCells[key].columnIndexArr.map(field => {
              if (this.tableData[rowIndex][field] != this.tableDataCopy[rowIndex][field]) {
                paramField[field] = this.tableData[rowIndex][field];//字段：改变的值
                //cells.push(paramField);//所有改变值的字段存储起来
              }
            })
            let idCard = this.tableData[rowIndex].idCard;
            if (JSON.stringify(paramField) != JSON.stringify({})) {//map判空
              changCellFields[idCard] = paramField;
            }
          }
          let params = {
            add: this.$refs.table.getInsertRecords(),
            delete: this.$refs.table.getRemoveRecords(),
            update: this.$refs.table.getUpdateRecords(),
            batchId: this.batchId,
            templateId: this.templateId,
            changCellFields: changCellFields,
            isCompute: this.isCompute,
            regionId: this.regionId,
            payGroupId: this.payGroupId
          };
          this.$confirm('是否保存修改?', '提示', {
            confirmButtonText: '确定',
            cancelButtonText: '取消',
            type: 'warning'
          }).then(() => {
            this.loadingLevel_1 = true
            saveItemData(params).then(res => {
              this.loadingLevel_1 = false
              let rs = res.data;
              if (rs.code == 0) {
                this.$message.success({
                  message: "保存成功",//提示的信息
                  offset: 100,
                  type: 'success',
                })
                //this.$emit('_getSalaryHistoryData');//调用父类刷新页面
                this.$router.go(0);//刷新当前页
              }
            })
          })
        }
      },
    },
  }
</script>

<style scoped>
  .el-link {
    margin-left: 20px;
    position: relative;
  }

  .detail > div .el-link:nth-of-type(1):before {
    content: '';
    position: absolute;
    width: 1px;
    height: 10px;
    background: rgba(216, 216, 216, 1);
    border-radius: 1px;
    left: -10px;
    top: 5px;
  }

  .detail > div {
    padding-right: 10px;
  }

  .el-link:after {
    content: '';
    position: absolute;
    width: 1px;
    height: 10px;
    background: rgba(216, 216, 216, 1);
    border-radius: 1px;
    right: -10px;
    top: 5px;
  }

  .reload-flex {
    display: flex;
    justify-content: center;
    align-items: center;
    padding: 0 80px;

  }

  .reload-flex .icon-wrap {
    text-align: center;
    flex: 1;
  }

  .reload-flex .icon-wrap .icon {
    text-align: center;
    font-size: 40px;
    color: #0EA5E5;
    font-weight: bold;
    margin-bottom: 10px;
  }

  .detailTop {
    display: flex;
    justify-content: space-between;
    align-items: center;
  }

  .detailTop div .mark {
    display: inline-block;
    width: 31px;
    height: 17px;
    background: rgba(253, 242, 184, 1);
    border-radius: 1px;
    margin-right: 8px;
  }

  .detailTop div .mark:nth-of-type(1) {
    background: rgba(252, 229, 229, 1);
  }

  .detailTop div span {
    vertical-align: middle;
    font-size: 14px;
    font-family: PingFangSC-Regular, PingFang SC;
    font-weight: 400;
    color: rgba(102, 102, 102, 1);
    line-height: 20px;
  }

  .gridContain >>> .vxe-body--row .vxe-cell {
    height: 100%;
    padding: 0;
    line-height: 46px;
  }

  .gridContain >>> .vxe-body--row .vxe-cell .copyMsg {
    display: inline-block;
    width: 100%;
    height: 100%;
    background: rgba(252, 229, 229, 1);
  }

  .gridContain >>> .vxe-body--row .vxe-cell .updateMsg, .gridContain >>> .vxe-body--row .col--dirty .copyMsg {
    display: inline-block;
    width: 100%;
    height: 100%;
    background: rgba(253, 242, 184, 1);
  }
  .text-indent{
    list-style: none;
    padding-left: 20px
  }
</style>
<style>
  .vxe-table:not(.is--empty).show--foot.scroll--x .vxe-table--body-wrapper {
    overflow-x: hidden!important;
  }
</style>
